import React, { Fragment, useContext, useEffect, useState } from "react";
import { Box, Container, Typography, Grid, Button } from "@material-ui/core";
import { httpPost } from "../../lib/apiClients";
import { AxiosResponse } from "axios";
import { useNavigate, Link } from "react-router-dom";
import { passwordValid } from "../../lib/validation";
import ButtonLoader from "../../components/ButtonLoader";
import { auth } from "../../firebase";
import { AuthContext } from "../../auth/AuthContext";
import SectionHeader from "../../components/SectionHeader";
import { Environment } from "../../utils/environments";
export default function PasswordChange() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [resetError, setResetError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  useEffect(() => {
    document.title = "パスワード変更 | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
  }, [currentUser]);
  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    const isValid = passwordValid(newPassword);
    setIsPasswordValid(isValid);
    if (newPassword !== confirmPassword) {
      setPasswordMatch(false);
      setLoading(false);
    } else {
      setPasswordMatch(true);
    }
    if (isValid && newPassword === confirmPassword) {
      try {
        await httpPost({
          pathName: "password-change",
          bodyParams: {
            newPassword: newPassword,
            newPasswordConfirm: confirmPassword,
          },
        }).then((response: AxiosResponse<any>) => {
          if (Environment.getBuildType() != "prod") {
            console.log(response);
          }
          if (response.status == 200) {
            auth.signOut();
            navigate("/settings/password-change-complete");
          }
        });
      } catch (error) {
        if (Environment.getBuildType() != "prod") {
          console.log(error);
        }
        if (error.response.status >= 400 && error.response.status <= 499) {
          setResetError(true);
        } else {
          navigate(`/error?code=${error.response?.status}`);
        }
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      <Box component={"section"} className="section bg-dots">
        <Container className="container" style={{ marginBottom: "50px" }}>
          <SectionHeader
            currentPage={"パスワード変更"}
            preHeading={"Password Change"}
          />
        </Container>
        <Container className="container">
          <Box className="element-box">
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginBottom: "20px" }}
              >
                <Grid item md={3} sm={3} xs={12}>
                  <label>
                    新しいパスワード<span className="required">必須</span>
                  </label>
                </Grid>
                <Grid item md={6} sm={9} xs={12}>
                  <input
                    maxLength={12}
                    type="password"
                    placeholder="新しいパスワード"
                    className="input-field"
                    onChange={(e) => {
                      setNewPassword(e.target.value.trim());
                    }}
                    required
                  />
                  {!isPasswordValid && (
                    <Typography style={{ color: "red", marginTop: "1rem" }}>
                      パスワードを半角英数記号6文字以上12文字以内で入力してください
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginBottom: "20px" }}
              >
                <Grid item md={3} sm={3} xs={12}>
                  <label>
                    新しいパスワード（確認）
                    <span className="required">必須</span>
                  </label>
                </Grid>
                <Grid item md={6} sm={9} xs={12}>
                  <input
                    maxLength={12}
                    type="password"
                    placeholder="新しいパスワード"
                    className="input-field"
                    onChange={(e) => {
                      setConfirmPassword(e.target.value.trim());
                    }}
                    required
                  />
                  {!passwordMatch && (
                    <Typography style={{ color: "red", marginTop: "1rem" }}>
                      新しいパスワードと新しいパスワード（確認）が異なります
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ margin: "30px 0", textAlign: "center" }}
                >
                  {loading && <div className="button-overlay"></div>}

                  <button
                    className="classification-btn"
                    type="submit"
                    disabled={
                      newPassword == "" || confirmPassword == "" || loading
                    }
                  >
                    {loading ? (
                      <ButtonLoader />
                    ) : (
                      <span style={{ fontWeight: "bolder" }}>
                        パスワード変更
                      </span>
                    )}
                  </button>
                  {resetError && (
                    <Typography className="error-message">
                      パスワード変更ができません。
                      <br />
                      ご不明な点がございましたら、下記のお問い合わせフォームより、お気軽に運営事務局までお問い合わせください
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </form>
            <Typography component={"p"} className="text-center">
              <Link
                to={"/settings"}
                style={{
                  borderBottom: "1px solid",
                  color: "var(--secondary-color)",
                }}
              >
                お客様情報画面
              </Link>
              に戻る
            </Typography>
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
}
